import { useTranslation } from 'react-i18next';

import { ReactComponent as ChevronDownIcon } from '../../../../assets/icons/chevron-down.svg';
import type { IPaginationProps } from '../../../interfaces/globals';
import { TRANSLATIONS_GLOBAL } from '../../../translations/commons';
import CustomButton from '../../Buttons/CustomButton/CustomButton';

import './Pagination.scss';

const Pagination = ({ page, totalPages, total, pageSize, onPageChange, className }: IPaginationProps) => {
  const { t } = useTranslation();

  if (totalPages <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const rootClass = ['pagination', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      <span className="pagination__count" aria-live="polite">
        {total === 0
          ? t(TRANSLATIONS_GLOBAL.pagination.empty)
          : t(TRANSLATIONS_GLOBAL.pagination.range, { from, to, total })}
      </span>

      <div className="pagination__nav">
        <CustomButton
          variant="default"
          size="s"
          className="pagination__arrow pagination__arrow--previous"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label={t(TRANSLATIONS_GLOBAL.pagination.previous)}
        >
          <ChevronDownIcon aria-hidden="true" />
        </CustomButton>

        <span className="pagination__page">{t(TRANSLATIONS_GLOBAL.pagination.page, { page, total: totalPages })}</span>

        <CustomButton
          variant="default"
          size="s"
          className="pagination__arrow pagination__arrow--next"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          aria-label={t(TRANSLATIONS_GLOBAL.pagination.next)}
        >
          <ChevronDownIcon aria-hidden="true" />
        </CustomButton>
      </div>
    </div>
  );
};

export default Pagination;
